import { render, staticRenderFns } from "./SearchResultFilter.vue?vue&type=template&id=d8796d62"
import script from "./SearchResultFilter.vue?vue&type=script&lang=js"
export * from "./SearchResultFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports